import { render, staticRenderFns } from "./BudgetEditForm.vue?vue&type=template&id=55a41f19&"
import script from "./BudgetEditForm.vue?vue&type=script&lang=js&"
export * from "./BudgetEditForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports